import studentsGGG from "@assets/icons/menus/children-g.png"
import students from "@assets/icons/menus/children.png"
import { IconImageM } from "@common/components/icons/IconsM"
import { incrementStudentMessengerNotReadCount } from "@data/redux/actions/data"
import { hasRole } from "@data/utility/ability"
import { nextInterviewForStudent } from "@data/utility/dataUtils"
import * as Notifications from "expo-notifications"
import moment from "moment"
import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import graduateG from "../../assets/icons/menus/graduate-g.png"
import graduate from "../../assets/icons/menus/graduate.png"
import homeG from "../../assets/icons/menus/home1-g.png"
import home from "../../assets/icons/menus/home1.png"
import loupeG from "../../assets/icons/menus/loupe-g.png"
import loupe from "../../assets/icons/menus/loupe.png"
import schoolG from "../../assets/icons/menus/school-g.png"
import school from "../../assets/icons/menus/school.png"
import writeG from "../../assets/icons/menus/write-g.png"
import write from "../../assets/icons/menus/write.png"
import targetG from "../../assets/icons/menus/offre-g.png"
import target from "../../assets/icons/menus/offre.png"
import ReviewActivitiesTabScreen from "../reviewer/ReviewActivitiesTabScreen"
import Schools from "../school/Schools"
import { findClosestNextOccurrence } from "../student/account/onboarding/LiveRoomCard"
import Classrooms from "../teacher/classrooms/Classrooms"
import TutorApplicationScreen from "./application/TutorApplicationScreen"
import TutorHomeTabScreen from "./home/TutorHomeTabScreen"
import TutorResources from "./home/tutorResources/TutorResources"
import MyStudentsTabScreen from "./students/MyStudentsTabScreen"
import ProposalsTabScreen from "./proposals/ProposalsTabScreen"

export const tutorTabScreens = (user) => {
    const iconSize = 36

    const dispatch = useDispatch()
    useEffect(() => {
        const subscription = Notifications.addNotificationReceivedListener(
            (notification) => {
                if (notification.request.content.data.path === "messages") {
                    dispatch(
                        incrementStudentMessengerNotReadCount(
                            notification.request.content.data.data?.owner_id
                        )
                    )
                }
            }
        )
        return () => subscription.remove()
    }, [])

    const countMessageNotifications = user?.students?.reduce(
        (pValue, cValue) => cValue?.student_messenger_not_read_count + pValue,
        0
    )

    const homeNotifications =
        user?.live_sessions?.filter((liveSession) => {
            const closestNextOccurrence = findClosestNextOccurrence([
                liveSession,
            ])

            const liveMoment = closestNextOccurrence?.date
                ? moment(closestNextOccurrence?.date)
                : null

            if (!liveMoment) return false

            return liveMoment?.isSame(moment(), "day")
        })?.length +
        user?.students
            ?.map((x) => nextInterviewForStudent(x))
            ?.filter((x) => !!x)
            ?.filter((interview) => {
                return (
                    moment(interview?.date_time).isSame(moment(), "day") ||
                    moment(interview.date_time).diff(moment(), "day") <= 0
                )
            })?.length

    return [
        {
            name: "dashboard",
            component: hasRole(user, "tutor-candidate")
                ? TutorApplicationScreen
                : TutorHomeTabScreen,
            can: "my_tutor_profile_completion",
            options: {
                tabBarIcon: (status) =>
                    status?.focused ? (
                        <IconImageM width={iconSize} source={home} />
                    ) : (
                        <IconImageM width={iconSize} source={homeG} />
                    ),
                headerTitle: "Tableau de bord",
                headerShown: false,
                tabBarItemStyle: {
                    width: iconSize + 100,
                },
                tabBarBadge: homeNotifications > 0 ? homeNotifications : null,
            },
        },
        {
            name: "schools",
            component: Schools,
            can: "schools",
            options: {
                tabBarIcon: (status) =>
                    status?.focused ? (
                        <IconImageM width={iconSize} source={school} />
                    ) : (
                        <IconImageM width={iconSize} source={schoolG} />
                    ),
                headerTitle: "Écoles",
                headerShown: false,
                tabBarItemStyle: {
                    width: iconSize + 100,
                },
            },
        },
        {
            name: "classrooms",
            component: Classrooms,
            can: "classroom",
            options: {
                tabBarIcon: (status) =>
                    status?.focused ? (
                        <IconImageM width={iconSize} source={graduate} />
                    ) : (
                        <IconImageM width={iconSize} source={graduateG} />
                    ),
                headerTitle: "Mes classes",
                headerShown: false,
                tabBarItemStyle: {
                    width: iconSize + 100,
                },
            },
        },
        {
            name: "students",
            component: MyStudentsTabScreen,
            can: "my_students",
            options: {
                tabBarIcon: (status) =>
                    status?.focused ? (
                        <IconImageM width={iconSize * 1.1} source={students} />
                    ) : (
                        <IconImageM
                            width={iconSize * 1.1}
                            source={studentsGGG}
                        />
                    ),
                tabBarBadge:
                    countMessageNotifications > 0
                        ? countMessageNotifications
                        : null,
                headerTitle: "Mes élèves",
                headerShown: false,
                tabBarItemStyle: {
                    width: iconSize + 100,
                },
            },
        },
        // Only show proposals tab if user has at least one permission
        ...((() => {
            // Une offre CIBLÉE rouvre l'onglet à un tuteur qui ne prend pas de missions
            // fixes : elle lui est adressée nommément, il doit pouvoir y répondre puis
            // la relire une fois acceptée. `fixed_missions` dit ce que l'ops peut lui
            // PROPOSER, pas ce qu'il peut LIRE. Le compteur ne compte que des lignes que
            // l'onglet montrera vraiment, donc rouvrir ne peut pas donner un onglet vide.
            const canShowGroupsTab =
                user?.profile?.fixed_missions === 1 ||
                (user?.group_attribution_proposals_meta?.targeted_count || 0) > 0
            const canShowReplacementsTab = user?.profile?.replace_missions === 1
            const canShowTrialsTab = user?.profile?.accept_trials === 1

            // Hide entire tab if user has no permissions
            if (!canShowGroupsTab && !canShowReplacementsTab && !canShowTrialsTab) {
                return []
            }

            return [{
                name: "proposals",
                component: ProposalsTabScreen,
                can: "my_students",
                options: {
                    tabBarIcon: (status) =>
                        status?.focused ? (
                            <IconImageM width={iconSize} source={target} />
                        ) : (
                            <IconImageM width={iconSize} source={targetG} />
                        ),
                    tabBarBadge: (() => {
                        const groupPendingCount = user?.group_attribution_proposals_meta?.pending_count || 0;
                        const substitutionPendingCount = user?.substitution_proposals_meta?.pending_count || 0;
                        const trialSessionProposalCount = user?.trial_attribution_proposals_meta?.pending_count || 0;

                        const totalPendingCount = groupPendingCount + substitutionPendingCount + trialSessionProposalCount;
                        return totalPendingCount > 0 ? totalPendingCount : null;
                    })(),
                    headerTitle: "Offres de cours",
                    headerShown: false,
                    tabBarItemStyle: {
                        width: iconSize + 100,
                    },
                },
            }]
        })()),
        {
            name: "activities-review",
            component: ReviewActivitiesTabScreen,
            can: "review_activities",
            options: {
                tabBarIcon: (status) =>
                    status?.focused ? (
                        <IconImageM width={iconSize} source={loupe} />
                    ) : (
                        <IconImageM width={iconSize} source={loupeG} />
                    ),
                tabBarBadge:
                    user?.pending_reviews_count > 0
                        ? user?.pending_reviews_count
                        : null,
                headerTitle: "Revue d'activités",
                headerShown: false,
                tabBarItemStyle: {
                    width: iconSize + 100,
                },
            },
        },
        {
            name: "tutor-resources",
            can: "tutor_resources",
            component: TutorResources,
            options: {
                tabBarIcon: (status) =>
                    status?.focused ? (
                        <IconImageM width={iconSize} source={write} />
                    ) : (
                        <IconImageM width={iconSize} source={writeG} />
                    ),
                headerTitle: "Ressources pédagogiques",
                headerShown: false,
                tabBarItemStyle: {
                    width: iconSize + 100,
                },
            },
        },
    ]
}
